<template>
  <div class="list-filter-input">
    <FilterInputCourse class="flex-1" />
    <!--
    <FilterInputGender v-if="!isMobile" />
-->
    <FilterInputMobile v-if="isMobile" class="w-12" />
  </div>
</template>

<script>
import detectDeviceMixin from '@helper/detectDeviceMixin'
import FilterInputCourse from '@/components/pages/tutor-list/filter/filter-input/filter-input-course.vue'
/*
import FilterInputGender from '@/components/pages/tutor-list/filter/filter-input/filter-input-gender.vue'
*/
import FilterInputMobile from '@/components/pages/tutor-list/filter/filter-input/filter-input-mobile.vue'

export default {
  name: 'TutorListFilterInput',
  components: { FilterInputMobile, FilterInputCourse },
  mixins: [detectDeviceMixin]
}
</script>

<style scoped lang="scss">
.list-filter-input {
  @apply flex space-x-2 items-center;
}
</style>
